var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronRightGray8Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "11px",
    viewBox: "0 0 8 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-right-id",
    transform: "translate(-350.000000, -195.800000)",
    stroke: "#C1C1C1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(355.750000, 29.750000) rotate(-90.000000) translate(-355.750000, -29.750000) ",
    id: "Path-3",
    points: "351 26 355 30 359 26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRightGray8Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Right_Gray-8px.2d047338d7a8ddc3ee3ef725abcf26fa.svg";
export { ForwardRef as ReactComponent };